import React, { useContext } from 'react'
import { Link } from 'gatsby'
import { SmallerContainer, ThemeContext } from 'components/common'
import { MagicalButton, Wrapper, Flex, FlexOne , Thumbnail } from './styles'
import hacker from '../../../../static/skills/hacker.svg'

export const Intro = () => {
	const { theme } = useContext(ThemeContext)
	return (
		<Wrapper theme={theme} as={SmallerContainer}>
				<FlexOne>
					<h1>I'm Serge Sipatrin</h1>
					<p>
						or just Sea Patrick, a  Full Stack JavaScript Developer.
					</p>
					<Flex>
					<MagicalButton
						href="https://drive.google.com/file/d/1Yd3t7vyBOb6KnzxVcQOVruKOIg5Je1kW/view?usp=sharing"
						rel="noopener noreferrer"
						target="_blank"
					>
						View resume
					</MagicalButton>
					<MagicalButton as={Link} to="/contact">
						Get In Touch
					</MagicalButton>
					</Flex>
				</FlexOne>
				<Thumbnail>
					<img src={hacker} alt="I’m Sea Patrick and I’m a Backend & Devops engineer!" />
				</Thumbnail>
		</Wrapper>
	)
}
